import {createAsyncThunk} from '@reduxjs/toolkit';
import fetchRequest from './utils';
import token from './token';

const withBearer = (authToken) => {
    if (!authToken) return null;
    return authToken.startsWith('Bearer ') ? authToken : `Bearer ${authToken}`;
};

export const getConversations = createAsyncThunk(
    'conversations/getConversations',
    async () => fetchRequest('/ai-assistant/conversations', 'GET', null, null, false, withBearer(token.get()))
);

export const getConversationMessages = createAsyncThunk(
    'conversations/getConversationMessages',
    async (conversationId) => fetchRequest(
        `/ai-assistant/conversations/${conversationId}/messages`,
        'GET',
        null,
        null,
        false,
        withBearer(token.get())
    )
);

export const updateConversation = createAsyncThunk(
    'conversations/updateConversation',
    async ({conversationId, title}) => {
        const payload = {title};
        try {
            return await fetchRequest(
                `/ai-assistant/conversations/${conversationId}`,
                'PATCH',
                null,
                payload,
                false,
                withBearer(token.get())
            );
        } catch (patchError) {
            try {
                return await fetchRequest(
                    `/ai-assistant/conversations/${conversationId}`,
                    'PUT',
                    null,
                    payload,
                    false,
                    withBearer(token.get())
                );
            } catch (putError) {
                throw new Error(putError.message || patchError.message || 'Unable to rename conversation.');
            }
        }
    }
);

export const deleteConversation = createAsyncThunk(
    'conversations/deleteConversation',
    async (conversationId) => fetchRequest(
        `/ai-assistant/conversations/${conversationId}`,
        'DELETE',
        null,
        null,
        false,
        withBearer(token.get())
    )
);
